import React from 'react';

const leaders = [
  {
    name: 'Balbinder Singh Bhatia',
    city: 'ABU DHABI',
    role: 'Founder & Chief Executive Officer (CEO)',
    img: 'https://res.cloudinary.com/rp2zwlm2/image/upload/v1784102433/profile_balbinder_a4tvtn.png',
    fallback: 'Balbinder+Singh+Bhatia',
    bio: '20+ years in TMT deal-making, private equity diligence, and AI moats. Serial leadership across multiple AI-native ventures and corporate boards.',
    pills: ['Accenture Strategy (M&A & PE)', 'Boston Analytics', 'TMT & AI Dealcraft', 'Global MBA', 'NVIDIA Certified CAIO'],
  },
  {
    name: 'Dr. Bharat Madan',
    city: 'LUXEMBOURG',
    role: 'President & Head of Global Strategy',
    img: 'https://res.cloudinary.com/rp2zwlm2/image/upload/v1784102433/profile_bharat_currim.png',
    fallback: 'Dr+Bharat+Madan',
    bio: '20+ years leading cross-border M&A, technology diligence, and digital transformation across Western Europe and the GCC.',
    pills: ['Aperam (Global Head)', 'EY Strategy Leader', 'Space-Tech', 'Arthur D. Little', 'École des Ponts DBA'],
  },
  {
    name: 'Maheshwar Damojipurapu',
    city: 'BENGALURU',
    role: 'Co-Founder & Chief Operating Officer (COO)',
    img: 'https://res.cloudinary.com/rp2zwlm2/image/upload/v1784102433/profile_maheshwar_etxduh.png',
    fallback: 'Maheshwar+Damojipurapu',
    bio: '20+ years in corporate strategy, enterprise tech, and AI innovation. Scaling complex software platforms and operations across the US, Europe, and Asia.',
    pills: ['Citrix Strategy', 'Enterprise Tech & AI', 'Platform Scaling', 'MBA'],
  },
  {
    name: 'Zuhaib Ahmed',
    city: 'DUBAI',
    role: 'Co-Founder & Chief Technology Officer (CTO)',
    img: 'https://res.cloudinary.com/rp2zwlm2/image/upload/v1784102435/profile_zuhaib_m672y0.jpg',
    fallback: 'Zuhaib+Ahmed',
    bio: 'AI systems architect with a proven track record leading AI-driven R&D. Creator of Frontier’s deterministic runtime and multi-agent IP.',
    pills: ['AI-Driven R&D', 'Multi-Agent IP', 'Deterministic AI', 'Hult MBA'],
  },
  {
    name: 'Thomas Kipp',
    city: 'DUBAI',
    role: 'Senior Operating Partner',
    img: 'https://res.cloudinary.com/rp2zwlm2/image/upload/v1784102434/profile_Thomas_dnaqza.jpg',
    fallback: 'Thomas+Kipp',
    bio: '25+ years leading global logistics networks, corporate incubations, and digital business models across Europe, the US, and Asia.',
    pills: ['DHL', 'Monitor Group (Partner)', 'Roland Berger', 'NVIDIA Certified CAIO'],
  },
];

// Section 3 — The partnership & executive bench (equal dignity across 5 principals).
export const LeadershipSection = () => (
  <section className="py-24 sm:py-32 px-6 sm:px-10 lg:px-16 border-b border-stone-200/80 bg-[#FFFFFF]">
    <div id="leadership" className="scroll-mt-20 w-full max-w-[1600px] mx-auto">

      <div className="max-w-3xl mb-14 sm:mb-20">
        <span className="mono text-[10px] uppercase tracking-widest text-[#F58220] font-semibold block mb-2">LEADERSHIP · STRATEGY & SYSTEMS</span>
        <h2 className="text-3xl sm:text-5xl font-medium tracking-tight text-stone-950 mb-4">Built by dealmakers, investors, and AI architects.</h2>
        <p className="text-base sm:text-lg text-stone-700 leading-relaxed font-sans max-w-2xl">
          Every leader at Frontier operates at the intersection of strategy and AI. Over two decades, our leaders have advised on marquee transactions for global institutions, while engineering the sovereign systems that power them.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-12 items-start">
        {leaders.map((l) => (
          <div key={l.name} className="flex flex-col group">
            <div className="w-full aspect-[4/5] rounded-3xl overflow-hidden bg-stone-200 shadow-sm border border-black/5 mb-5 relative">
              <img
                src={l.img}
                alt={`${l.name}, ${l.role}`}
                className="w-full h-full object-cover object-center filter grayscale contrast-[105%] group-hover:grayscale-0 transition-all duration-500"
                onError={(e) => { e.currentTarget.src = `https://placehold.co/800x1000/090E1A/FFFFFF?text=${l.fallback}`; }}
              />
            </div>
            <div>
              <div className="flex items-center justify-between mb-1">
                <h3 className="text-base font-bold text-stone-950 tracking-tight">{l.name}</h3>
                <span className="mono text-[10px] text-stone-500 font-medium">{l.city}</span>
              </div>
              <div className="text-xs font-semibold text-stone-700 mb-2">{l.role}</div>
              <p className="text-xs text-stone-600 leading-relaxed font-sans mb-3.5">{l.bio}</p>
              <div className="flex flex-wrap gap-1.5 pt-3 border-t border-stone-200/80">
                {l.pills.map((p) => (
                  <span key={p} className="mono text-[10px] text-stone-600 bg-stone-100 border border-stone-200/90 px-2 py-0.5 rounded-md font-medium">{p}</span>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

    </div>
  </section>
);
